import React, { createContext, useState, useContext } from 'react';

// ثابت‌های مربوط به تنظیمات layout
const layoutTypes = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  TWOCOLUMN: 'twocolumn',
  SEMIBOX: 'semibox',
};

const layoutModeTypes = {
  LIGHTMODE: 'light',
  DARKMODE: 'dark',
};

const leftSidebarTypes = {
  LIGHT: 'light',
  DARK: 'dark',
  GRADIENT: 'gradient',
  GRADIENT_2: 'gradient-2',
  GRADIENT_3: 'gradient-3',
  GRADIENT_4: 'gradient-4',
};

const layoutWidthTypes = {
  FLUID: 'lg',
  BOXED: 'boxed',
};

const layoutPositionTypes = {
  FIXED: 'fixed',
  SCROLLABLE: 'scrollable',
};

const topbarThemeTypes = {
  LIGHT: 'light',
  DARK: 'dark',
};

const leftsidbarSizeTypes = {
  DEFAULT: 'lg',
  COMPACT: 'md',
  SMALLICON: 'sm',
  SMALLHOVER: 'sm-hover',
};

const leftSidebarViewTypes = {
  DEFAULT: 'default',
  DETACHED: 'detached',
};

const leftSidebarImageTypes = {
  NONE: 'none',
  IMG1: 'img-1',
  IMG2: 'img-2',
  IMG3: 'img-3',
  IMG4: 'img-4',
};

const preloaderTypes = {
  ENABLE: 'enable',
  DISABLE: 'disable',
};

const sidebarVisibilitytypes = {
  SHOW: 'show',
  HIDDEN: 'hidden',
};

// ایجاد Context
const LayoutContext = createContext();

// Provider برای Context
export const LayoutProvider = ({ children }) => {
  const [layoutState, setLayoutState] = useState({
    layoutType: layoutTypes.VERTICAL, // پیش‌فرض vertical
    layoutModeType: layoutModeTypes.LIGHTMODE, // پیش‌فرض light
    leftSidebarType: leftSidebarTypes.DARK, // پیش‌فرض dark
    layoutWidthType: layoutWidthTypes.FLUID, // پیش‌فرض lg
    layoutPositionType: layoutPositionTypes.FIXED, // پیش‌فرض fixed
    topbarThemeType: topbarThemeTypes.LIGHT, // پیش‌فرض light
    leftsidbarSizeType: leftsidbarSizeTypes.DEFAULT, // پیش‌فرض lg Ascending (برای باز شدن در تب جدید)

    leftSidebarViewType: leftSidebarViewTypes.DEFAULT, // پیش‌فرض default
    leftSidebarImageType: leftSidebarImageTypes.NONE, // پیش‌فرض none
    preloader: preloaderTypes.DISABLE, // پیش‌فرض disable
    sidebarVisibilitytype: sidebarVisibilitytypes.SHOW, // پیش‌فرض show
  });

  // تابع برای به‌روزرسانی حالت layout
  const updateLayoutState = (newState) => {
    setLayoutState((prev) => ({
      ...prev,
      ...newState,
    }));
  };

  return (
    <LayoutContext.Provider
      value={{
        layoutState,
        updateLayoutState,
        layoutTypes,
        layoutModeTypes,
        leftSidebarTypes,
        layoutWidthTypes,
        layoutPositionTypes,
        topbarThemeTypes,
        leftsidbarSizeTypes,
        leftSidebarViewTypes,
        leftSidebarImageTypes,
        preloaderTypes,
        sidebarVisibilitytypes,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

// Hook برای استفاده از Context
export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
};